import React, {useEffect, useState,useLayoutEffect} from "react";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import {getcategorymenu,getMyProduct} from "../../../service/myProductService";
import {responsiveproductlistmobile5}  from "../../../utils/constant";
import {Item} from "../../../components/mobile/product";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";


import "./css/san-xu.css";

const SanXu=()=> {
    const location = useLocation();
    const InfiniteScroll = ({ loadMore }) => {
        useEffect(() => {
          const handleScroll = () => {
            var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
            if (check === 0 || check === 1){
                loadMore();
             }
          };
      
          window.addEventListener("scroll", handleScroll);
          return () => {
            window.removeEventListener("scroll", handleScroll);
          };
        }, [loadMore]);
      
        return null;
    };

    const [categoryId, setCategoryId] = useState('');
    const handleClickGetProductByCategiryId=(id)=>{
        setCategoryId(id);
        setLoadMoreStartProduct(0);
        setItemDataProduct([]);
        getDataProduct(0,id);
    }

    // list cate 
    const [category, setCategory] = useState([]);
    const [childCategory, setChildCategory] = useState([]);
    const getDataCategory=()=>{
        try{
            getcategorymenu().then((response) => {
                if(response.status == 200 && response.message.length >0  && response.message !== "Không tìm thấy dữ liệu."){
                    setCategory(response.message);
                    var obj = {};

                    setCategoryId(response.message[0].items.join(','));   
                    response.message.forEach(element => {
                        if(element.children.length>0){
                            obj[element._id] = element.children;
                        }
                    });
                    //setChildBefor(response.message[0].children);
                }               
              });
        }catch(e){
            console.log(e);
        }
    }

    const [itemDataProduct, setItemDataProduct] = useState([]);
    const [loadMoreStartProduct, setLoadMoreStartProduct] = useState(0);
    const [totalItemProduct, setTotalItemProduct] = useState(0);
    // const [metadata, setMetadata] = useState([]);
    const getDataProduct = (start,catId) => {
        try{
            getMyProduct(catId, start, '', '', '','', 8).then((response) => {
                if(response.status !== 426 || response.status !== 500){
                    if(response.status === 200 && response.message.length >0  && response.message !== "Không tìm thấy dữ liệu."){
                        setItemDataProduct((prevData) => [...prevData, ...response.message]);
                        setTotalItemProduct(response.metadata?.total_item);
                    }
                }                
            });
        }catch(e){
            console.log(e);
        }   
    }; 
    const handleLoadMoreProduct = (e) => {
        const newStart = loadMoreStartProduct + 1;
        setLoadMoreStartProduct(newStart);
        getDataProduct(newStart,categoryId);
    };
    const time = new Date();
    useEffect(()=>{
        getDataCategory();
        setLoadMoreStartProduct(0);
        getDataProduct(0, '');
        try{
            var _sku_list = [];
            itemDataProduct.forEach((item)=>{
                _sku_list.push(item?.sku);
            });
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Danh sách sản phẩm săn xu", 0,0,'index','inWeb',_sku_list,'Website Mobile').then((response)=>{
                console.log('send tracking');
            });
        }catch(e){console.log(e)}
    },[])
    const [scrollPosition, setPosition] = useState(0);
    useLayoutEffect(() => {
        function updatePosition() {
          setPosition(window.pageYOffset);
          window.localStorage.setItem("scrollPosition", window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();

        return () => window.removeEventListener('scroll', updatePosition);
    }, []);

    return(
        <Layout>
             <HeaderMobile Type={'Header2'} showBanner={false} linkBanner="" showText = {true} showSearchIcon= {true} showNoti = {true} showCart = {true} showTitle = {"SĂN XU"} />
            <div id="content_hangmoi"> 
                <div className={scrollPosition >40 ?("row pdt-5 bg-white fix-menu-category mgx-0"):("row pdt-5 bg-white mgx-0")}>
                    {
                        category.length>0?(
                            <Carousel key="category"
                            responsive={responsiveproductlistmobile5}
                            controls={false}
                            indicators={false}
                            nextIcon="" 
                            nextLabel=""
                            >
                            {
                                category.map((item, i)=>{

                                    return <div key={i} className={categoryId === item.items.join(',') ? ("select-border-bt"):("") } onClick={()=>handleClickGetProductByCategiryId(item.items.join(','))}>
                                    <div className='row'>
                                        <div className='col-12 in-f'><img className="icon-img" src={item.icon?.selected} alt={item.name}/></div>
                                        <div className='col-12 pdy-10 in-f'><span className="text-item-category">{
                                    item?.name?.length > 10 ? ( (item?.name).substring(0, 10) +'...') :(item?.name)
                                    }</span></div>
                                    </div>
                                </div>
                                })
                            }
                            </Carousel>
                            
                        ):(null)
                    }
                    <div className="bg-fff"></div>
                </div>   
                <div className="row pdx-5">
                    <ul className="row col-ul-1">
                        {
                            itemDataProduct.length > 0 ? 
                            (
                                itemDataProduct.map((item, j)=>{
                                return <Item item={item} index={time+item.sku+j}/>
                                })
                            )
                            :
                            (null)
                        }                
                    </ul>
                    <InfiniteScroll loadMore={handleLoadMoreProduct} />
                    {
                    +totalItemProduct - +itemDataProduct.length >0 ?(
                            <div className="loading-page-app-item pdy-5" style={{textAlign:"center"}}> <img src="/../images/loading.gif" alt="icon"/></div>
                        ):(null)
                    }
                </div>   
            </div>   
        </Layout>
    )
}
export default SanXu;